/**
 * Copyright (c) 2020
 *
 * @summary calls to dataReport/competition API
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2020-11-17 10:21:56
 * Last modified  : 2020-11-17 15:31:17
 */

import axios from '@/api/axios.js'

export default {

    /**
     * @param projectId int
     * @returns Promise
     */
    readBestProgression (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/best-progression`, filters)
    },


    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readCompetitorCompare (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/compare-performance`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readMarketLeader (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/market-leader`, filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readMarketLeaderSparkline (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/market-leader/sparkline`, filters)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readMyRank (projectId) {
        return axios.get(`/report/data/projects/${projectId}/competition/my-rank`)
    },

    /**
     * @param projectId int
     * @returns Promise
     */
    readNewCompetitor (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/new-competitor`, filters)
    },



    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readVisibilityEvolution (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/visibility-evolution`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readMarketLeaderVisibilityEvolution (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/market-leader-visibility-evolution`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readMarketLeaderKeywords (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/market-leader-keywords`,filters)
    },

    /**
     * @param projectId int
     * @param filters
     * @returns Promise
     */
    readMarketLeaderPages (projectId, filters=null) {
        return axios.get(`/report/data/projects/${projectId}/competition/market-leader-pages`,filters)
    },
};
